import {GridCustomCellProps} from "@progress/kendo-react-grid";
import React from "react";
import moment from "moment";
import { excelDateFormat } from "@taskpane/types";

export const DateCell = (props: GridCustomCellProps) => {
  return (<td>
    {moment(props.dataItem.EntryDate).year() > 1 && moment(props.dataItem.EntryDate).format(excelDateFormat)}
    </td>);
}
